module.exports = __webpack_public_path__ + "public/img/tips-circle.b0a64346.png";